import '../App.css';
import React from 'react';
import Header2 from '../Component/Header';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
// import { Form } from 'react-bootstrap';
import moment from 'moment-timezone';
import { connect } from 'react-redux'
import Moment from 'moment-timezone';
import Table from 'react-bootstrap/Table';
import { language } from '../language';
import { Form, Button } from 'react-bootstrap';
import { Platformcolor } from '../static/PlatformColor';

const { getWBD82 } = require('../Api');
const utilizeScroll = () => {
  
  const elRef = React.createRef();
  const executeScroll = () => elRef.current.scrollIntoView({behavior: "smooth", block: "end", inline: "nearest"});

  return { executeScroll, elRef };
};

class GrandTotalNumberBySBD extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      UserID: this.props.userID,
      Username: this.props.username,
      TodayDate: moment(new Date()).format('DD/MM/YYYY (ddd)'),
      Min_Date: Moment(new Date()).toDate(),
      Max_Date: Moment(new Date()).toDate(),
      SelectedDate: Moment(new Date()).toDate(),
      SearchValue: '',
      TextResult: '',
      showShare: true,
      showMAG: true,
      showDMC: true,
      showTOTO: true,
      showSG: true,
      showBT4: true,
      showSTC: true,
      showSBH: true,
      showSWK: true,
      showNumbering: false,
      ChooseStatus: 300, 
      ScrollViewNumb: 6600,
      GameArray: [],
      UseridReport: '', 
      MinimumAmount: '-',
      MaximumAmount: '-',
      MinimumType: 'B,S,SA,SB,SC',
      Loading: false,
      MinimumShowStatus: 'Hide',
      MinimumShowNumber: 'Show',
      ObjectKeys: ['5', '6', '7'],
      WebKeys: ['i82'],
      PopScrollBackButton: false,
      LoadingPage: false,
      BetweenType: '-',
      SearchNumber: '',
      searchbox: false,
      searchboxi82: true,
      showTotal: [],
      toEatBS: 50,
      toEatSA: 5,
    }
    this.SelectedOptionStatus = this.SelectedOptionStatus.bind(this);
    this.Platformcolor = this.Platformcolor.bind(this);
    this.elScroll = utilizeScroll();
  }

  async componentDidMount(){
    if (this.props.Role === 'superAdmin' || this.props.Role === 'Admin') {
      this.setState({  MinimumShowNumber: 'Hide'}, () => {
        // console.log('showNumbering', this.state.showNumbering)
      })
    }
    let ObjectKeys = ['5', '6', '7']
    this.setState({ ObjectKeys: ObjectKeys })
  }

  async ConfirmSearch(type){
    this.setState({ LoadingPage: true, Loading: false })
    const dateToCall = moment(this.state.SelectedDate).format('YYYY-MM-DD')

    const promisesarray = []
    promisesarray.push(getWBD82(dateToCall, this.props.token, this.props.username))
    const result = await Promise.all(promisesarray)
    const numbertoShow = {
      '5': {},
      '6': {},
      '7': {},
    }
    const showTotalObject = {
      'i82': {},
    }
    for (let i = 0; i < result.length; i += 1) {
      if (this.state.searchboxi82 && i === 0) {
        const resultarray = result[i]
        for (let j = 0; j < resultarray.length; j += 1) {
          if (!numbertoShow[resultarray[j].Platform][resultarray[j].Word]) {
            numbertoShow[resultarray[j].Platform][resultarray[j].Word] = {
              BS: 0,
              B: 0,
              S: 0,
              SA: 0,
            }
          }
          if (!showTotalObject.i82[resultarray[j].Word]) {
            showTotalObject.i82[resultarray[j].Word] = { BS: 0, B: 0, S: 0, SA: 0 }
          }
          if (Number(resultarray[j].B)) {
            numbertoShow[resultarray[j].Platform][resultarray[j].Word].BS += Number(resultarray[j].B)
            numbertoShow[resultarray[j].Platform][resultarray[j].Word].B += Number(resultarray[j].B)
            showTotalObject.i82[resultarray[j].Word].B += Number(resultarray[j].B)
            showTotalObject.i82[resultarray[j].Word].BS += Number(resultarray[j].B)
          }
          if (Number(resultarray[j].S)) {
            numbertoShow[resultarray[j].Platform][resultarray[j].Word].S += Number(resultarray[j].S)
            numbertoShow[resultarray[j].Platform][resultarray[j].Word].BS += Number(resultarray[j].S)
            showTotalObject.i82[resultarray[j].Word].S += Number(resultarray[j].S)
            showTotalObject.i82[resultarray[j].Word].BS += Number(resultarray[j].S)
          }
          if (Number(resultarray[j].SA)) {
            numbertoShow[resultarray[j].Platform][resultarray[j].Word].SA += Number(resultarray[j].SA)
            showTotalObject.i82[resultarray[j].Word].SA += Number(resultarray[j].SA)
          }
        }
      } else if (!this.state.searchboxi82 && i === 0) {
        // ignore
      } else {
        
      }
    }
    const gamearray = {
      '5': [],
      '6': [],
      '7': [],
    }
    for (let i = 5; i <= 7; i += 1) {
      const istring = i.toString()
      const wordarray = Object.keys(numbertoShow[istring])
      for (let j = 0; j < wordarray.length; j += 1) {
        gamearray[istring].push({
          Word: wordarray[j],
          BS: numbertoShow[istring][wordarray[j]].BS,
          B: numbertoShow[istring][wordarray[j]].B,
          S: numbertoShow[istring][wordarray[j]].S,
          SA: numbertoShow[istring][wordarray[j]].SA,
        })
      }
      gamearray[istring] = gamearray[istring].sort((a, b) => a.BS > b.BS ? -1 : 1);
      if (wordarray.length > 0) {
        gamearray[istring].GameBoolean = true
      }
    }
    const showTotal = {
      'i82': [],
    }
    for (let i = 0; i < 1; i += 1) {
      let platform = 'i82'
      const wordarray = Object.keys(showTotalObject[platform])
      for (let j = 0; j < wordarray.length; j += 1) {
        showTotal[platform].push({
          Word: wordarray[j],
          BS: showTotalObject[platform][wordarray[j]].BS,
          B: showTotalObject[platform][wordarray[j]].B,
          S: showTotalObject[platform][wordarray[j]].S,
          SA: showTotalObject[platform][wordarray[j]].SA,
        })
      }
      showTotal[platform] = showTotal[platform].sort((a, b) => a.BS > b.BS ? -1 : 1);
      if (wordarray.length > 0) {
        showTotal[platform].GameBoolean = true
      }
    }
    this.setState({ GameArray: gamearray, LoadingPage: false, Loading: true, showTotal })
  }

  toggleResult(platform) {
    let EditBoolean = this.state.GameArray
    EditBoolean[platform] = {...EditBoolean[platform], ...{GameBoolean: !(EditBoolean[platform].GameBoolean)}}
    this.setState({GameArray: JSON.parse(JSON.stringify( EditBoolean))})
  }

  textChange(value, Type){
    if (/^[0-9-]+$/.test(value) || value === '') {

      this.setState({ [Type]: JSON.parse(JSON.stringify(value))}, ()=> {
      })
    } else {
      alert(`${language[this.props.currentLanguage].NumberOnly}`);
    }
  }

  onKeyEnter(event){
    if (event.key === 'Enter') {
      this.CallAPI();
    }
  }

  SelectedOptionStatus(event) {
    this.setState({ChooseStatus: event.target.value}, ()=>{
      this.CallAPI();
    });
  }

  async setSelectedDate(SelectedDate) {
    this.setState({ SelectedDate }, ()=>{
      // this.CallAPI();
    })
  }

  handleScroll(event) {
    var node = event.target;
    if (node.scrollTop > 500) {
      this.setState({
        PopScrollBackButton: true
      });
    } else {
      this.setState({
        PopScrollBackButton: false
      });
    }
  }

  async handleSearchText(e, field) {
    this.setState({ [field]: e.target.value })
  }

  KeyPress(e) {
    if(e.key === 'Enter') {
      this.ConfirmSearch();
    }
  }

  Platformcolor(platform, GDisplay) {
    if (platform === 'Default') return 'lightsteelblue'
    else if (platform === '1' || platform === 'M') return '#faf6b9'
    else if (platform === '2') return '#c8ccfd'
    else if (platform === '3' || platform === 'T') return '#FDBCBC'
    else if (platform === '4' || platform === 'S') return '#CCF2FF'
    return 'lightgray'
  }

  sortby(mode) {
    const gamearray = JSON.parse(JSON.stringify(this.state.GameArray))
    for (let i = 5; i <= 7; i += 1) {
      const istring = i.toString()
      gamearray[istring] = gamearray[istring].sort((a, b) => a[mode] > b[mode] ? -1 : 1);
      if (gamearray[istring].length > 0) {
        gamearray[istring].GameBoolean = true
      }
    }
    const showTotal = JSON.parse(JSON.stringify(this.state.showTotal))
    for (let i = 0; i < 4; i += 1) {
      let platform = ''
      if (i === 0) {
        platform = 'PT'
      } else if (i === 1) {
        platform = 'AA'
      } else if (i === 2) {
        platform = 'i82'
      }
      showTotal[platform] = showTotal[platform].sort((a, b) => a[mode] > b[mode] ? -1 : 1);
      if (showTotal[platform].length > 0) {
        showTotal[platform].GameBoolean = true
      }
    }
    this.setState({ GameArray: gamearray, LoadingPage: false, Loading: true, showTotal })
  }

  exportTxt() {
    const toEatBS = this.state.toEatBS
    const toEatSA = this.state.toEatSA
    const ObjectKeys = ['5', '6']
    let stringtoexport = ''
    for (let i = 0; i < ObjectKeys.length; i += 1) {
      stringtoexport += i === 0 ? '#7\n' : '#5\n'
      const thisplatform = JSON.parse(JSON.stringify(this.state.GameArray[ObjectKeys[i]]))
      for (let j = 0; j < thisplatform.length; j += 1) {
        const thisword = thisplatform[j]
        let toeatbsforthisword = Number(toEatBS)
        let toeatsaforthisword = Number(toEatSA)
        if (thisword.B >= toeatbsforthisword) {
          thisword.B -= toeatbsforthisword
        } else {
          toeatbsforthisword -= thisword.B
          thisword.B = 0
          if (thisword.S >= toeatbsforthisword) {
            thisword.S -= toeatbsforthisword
          } else {
            thisword.S = 0
          }
        }
        if (thisword.SA >= toeatsaforthisword) {
          thisword.SA -= toeatsaforthisword
        } else {
          thisword.SA = 0
        }
        if (thisword.B === 0 && thisword.S === 0 && thisword.SA === 0) {
          // ignore
        } else if (Number(thisword.B.toFixed(0)) === 0 && Number(thisword.S.toFixed(0)) === 0 && Number(thisword.SA.toFixed(0)) === 0) {
          // ignore
        } else {
          stringtoexport += `${thisword.Word}#${Number(thisword.B.toFixed(0))}#${Number(thisword.S.toFixed(0))}#${Number(thisword.SA.toFixed(0))}\n`
        }
      }
    }
    const element = document.createElement("a");
    const file = new Blob([stringtoexport],{ type: "text/plain" });
    element.href = URL.createObjectURL(file);
    element.download = `WBD_${moment().format('YYYYDDMM')}.txt`;
    document.body.appendChild(element);
    element.click();
  }

  render() {
    return (
      <div onScroll={(e) => this.handleScroll(e)} style={{ width: '100%', height: '100vh', flexDirection: 'column', overflowY: 'auto' }}> 
        <Header2 />
        {this.state.LoadingPage && 
        <>
          <div className='dcc' style={{ fontWeight: 'bold', fontSize: 30, height: '80vh'}}>{language[this.props.currentLanguage].Loading}</div>
        </>}
        {this.state.LoadingPage === false && 
        <>
          <div className="dcc mobileHeader"
            ref={this.elScroll.elRef}
            style={{
              paddingBottom: 0,
              justifyContent: 'space-between',
              paddingRight: 10,
              flexDirection: 'row',
              width: '100%'
            }}>
            <div style={{ justifyContent: 'center', display: 'flex', alignItems: 'center' }} >
              <div style={{fontSize: "18px", width: 100, fontWeight: 'bold'}}>{language[this.props.currentLanguage].Date} :</div>
              <DatePicker
                onChange = {(Date) => this.setSelectedDate(Date)}
                dateFormat = 'dd-MMM-yyyy'
                placeholder="Date"
                // popperPlacement="top-right"
                selected={this.state.SelectedDate}
                className={"form-control StyleDatePicker"}
                // withPortal
              />
              <Form.Check
                style={{ fontSize: 18, alignItems: 'center', display: 'flex', marginLeft: 5, fontWeight: 'bold' }}
                inline
                label={'I82'}
                type="checkbox"
                checked={this.state.searchboxi82}
                onChange={(e) => this.setState({ searchboxi82: !this.state.searchboxi82})}
              />
              <Button style={{ textAlign: 'center' , color: 'white', marginLeft: 10, width: 110, fontWeight: 'bold', marginBottom: 5 }}
                className="button2"
                variant="primary"
                onClick={() => this.ConfirmSearch()}>
                {language[this.props.currentLanguage].Search}
              </Button>
              <Button style={{ textAlign: 'center' , color: 'white', marginLeft: 10, width: 110, fontWeight: 'bold', marginBottom: 5 }}
                className="button2"
                variant="primary"
                onClick={() => this.sortby('BS')}>
                排 B+S
              </Button>
              <Button style={{ textAlign: 'center' , color: 'white', marginLeft: 10, width: 110, fontWeight: 'bold', marginBottom: 5 }}
                className="button2"
                variant="primary"
                onClick={() => this.sortby('B')}>
                排 B
              </Button>
              <Button style={{ textAlign: 'center' , color: 'white', marginLeft: 10, width: 110, fontWeight: 'bold', marginBottom: 5 }}
                className="button2"
                variant="primary"
                onClick={() => this.sortby('S')}>
                排 S
              </Button>
              <Button style={{ textAlign: 'center' , color: 'white', marginLeft: 10, width: 110, fontWeight: 'bold', marginBottom: 5 }}
                className="button2"
                variant="primary"
                onClick={() => this.sortby('SA')}>
                排 SA
              </Button>
            </div>
            <div style={{ justifyContent: 'center', display: 'flex', alignItems: 'center' }} >
              <input 
                style={{ width: 100, height: 30, marginRight: 10, textAlign: 'center'}}
                type="text"
                value={this.state.toEatBS}
                onChange={(e) => this.setState({toEatBS: e.target.value})}
              />
              <input 
                style={{ width: 100, height: 30, marginRight: 10, textAlign: 'center'}}
                type="text"
                value={this.state.toEatSA}
                onChange={(e) => this.setState({toEatSA: e.target.value})}
              />
              <Button style={{ textAlign: 'center' , color: 'white', width: '100' }}
                className="button2"
                variant="primary"
                onClick={() => this.exportTxt()}>
                打钉
              </Button>
            </div>
          </div>
          <div style={{display: 'flex'}}>
            {(this.state.Loading && this.state.GameArray !== 'No Data') && <Table responsive="sm" style={{ backgroundColor: 'white', width: '40%', borderRight: '5px solid black', minHeight: 1000 }}>
              <div className="column" style={{ justifyContent: 'center', display: 'flex', paddingLeft: 10 }} >
                {  this.state.ObjectKeys.map((item, index) =>{
                  return (this.state.GameArray[item].GameBoolean) && <div key={index} style={{ paddingBottom: 40, marginRight: 10 }}>
                    <Table>
                      <thead>
                        <tr style={{
                          fontWeight: 'bold',
                          backgroundColor: Platformcolor(item, ''),
                          color: (item === '1') ? 'black' : (item === '7') ? 'black' : (item === '4') ? 'black' : 'white'}} >
                          <th colSpan={4} ><div  style= {{ fontSize: '15px'}}>{(item === '1') ? `${language[this.props.currentLanguage].magnum}` : 
                            (item === '2') ? `${language[this.props.currentLanguage].damacai}` : 
                              (item === '3') ? `${language[this.props.currentLanguage].toto}`: 
                                (item === '4') ? `${language[this.props.currentLanguage].singapore}`:
                                  (item === '5') ? `${language[this.props.currentLanguage].sarawak}`:
                                    (item === '6') ? `${language[this.props.currentLanguage].sabah}`: 
                                      (item === '7') ? `${language[this.props.currentLanguage].sandakan}`: 
                                        (item === '9') ? `Lotto 9` :
                                          `${language[this.props.currentLanguage].america}` }</div></th>
                        </tr>
                      </thead>
                      <thead>
                        <tr>
                          {(this.state.MinimumShowNumber === 'Show') ? 
                            <th style={{  }}><div>No</div></th>
                            :<></>
                          }
                          <th style={{ padding: 2 }}><div>N</div></th>
                          <>
                            <th style={{ padding: 2}}><div>B+S</div></th>
                            <th style={{ padding: 2}}><div>B</div></th>
                            <th style={{ padding: 2}}><div>S</div></th>
                            <th style={{ padding: 2}}><div>SA</div></th>
                          </>
                          {(this.state.MinimumShowStatus === 'Show')&&<th style={{ padding: 2 }}><div>{language[this.props.currentLanguage].Singular}</div></th>}
                        </tr>
                      </thead>
                      <tbody>
                        { Object.keys(this.state.GameArray[item]).map((NumberItem, ind) =>{
                          return <tr key={ind}>
                            {(this.state.MinimumShowNumber === 'Show') ? 
                              ( Object.keys(this.state.GameArray[item]).length -1 !== ind) &&<th style={{ }}>{ind+1}</th>
                              :<></>
                            }
                            {(NumberItem !== 'Amount' && NumberItem !== 'GameBoolean') && <th style={{ padding: 2, color: 'black', backgroundColor: '#9AFFF0'}} >{this.state.GameArray[item][NumberItem]['Word'] }</th>}
                            <>
                              {(NumberItem !== 'Amount' && NumberItem !== 'GameBoolean') &&<th style={{ padding: 2, backgroundColor: this.Platformcolor(item, ''),borderRight: '1px solid black'}}>{Number(this.state.GameArray[item][NumberItem]['BS']).toFixed(2)}</th>}
                              {(NumberItem !== 'Amount' && NumberItem !== 'GameBoolean') &&<th style={{ padding: 2, backgroundColor: this.Platformcolor(item, ''),borderRight: '1px solid black'}}>{Number(this.state.GameArray[item][NumberItem]['B']).toFixed(2)}</th>}
                              {(NumberItem !== 'Amount' && NumberItem !== 'GameBoolean') &&<th style={{ padding: 2, backgroundColor: this.Platformcolor(item, ''),borderRight: '1px solid black'}}>{Number(this.state.GameArray[item][NumberItem]['S']).toFixed(2)}</th>}
                              {(NumberItem !== 'Amount' && NumberItem !== 'GameBoolean') &&<th style={{ padding: 2, backgroundColor: this.Platformcolor(item, '')}}>{Number(this.state.GameArray[item][NumberItem]['SA']).toFixed(2)}</th>}
                            </>
                      
                            {(this.state.MinimumShowStatus === 'Show')&& (NumberItem !== 'Amount' && NumberItem !== 'GameBoolean') &&<th style={{ paddingRight: 5, paddingLeft: 5}}>{Number(this.state.GameArray[item][NumberItem]['TotalOrderCount'])}</th>}
                          </tr>
                        })}
                      </tbody>
                    </Table>
                  </div>
                })
                }
              </div>
            </Table>}
            {(this.state.Loading && this.state.showTotal !== 'No Data') && <Table responsive="sm" style={{ backgroundColor: 'white', width: '40%' }}>
              <div className="column" style={{ justifyContent: 'center', display: 'flex' }} >
                {  this.state.WebKeys.map((item, index) =>{
                  return (this.state.showTotal[item].GameBoolean) && <div key={index} style={{ paddingBottom: 40, marginRight: 10, paddingLeft: 10 }}>
                    <Table>
                      <thead>
                        <tr style={{
                          fontWeight: 'bold'}} >
                          <th colSpan={(this.state.MinimumShowNumber === 'Show') ? 4 : 3} ><div  style= {{ fontSize: '15px'}}>{item}</div></th>
                        </tr>
                      </thead>
                      <thead>
                        <tr>
                          {(this.state.MinimumShowNumber === 'Show') ? 
                            <th style={{ padding: 2,  }}><div>No</div></th>
                            :<></>
                          }
                          <th style={{ padding: 2,  }}><div>N</div></th>
                          <>
                            <th style={{ padding: 2 }}><div>B+S</div></th>
                            <th style={{ padding: 2 }}><div>B</div></th>
                            <th style={{ padding: 2 }}><div>S</div></th>
                            <th style={{ padding: 2 }}><div>SA</div></th>
                          </>
                          {(this.state.MinimumShowStatus === 'Show')&&<th style={{  padding: 2,   }}><div>{language[this.props.currentLanguage].Singular}</div></th>}
                        </tr>
                      </thead>
                      <tbody>
                        { Object.keys(this.state.showTotal[item]).map((NumberItem, ind) =>{
                          return <tr key={ind}>
                            {(this.state.MinimumShowNumber === 'Show') ? 
                              ( Object.keys(this.state.showTotal[item]).length -1 !== ind) &&<th style={{ }}>{ind+1}</th>
                              :<></>
                            }
                            {(NumberItem !== 'Amount' && NumberItem !== 'GameBoolean') && <th style={{ padding: 2, color: 'black', backgroundColor: '#9AFFF0'}} >{this.state.showTotal[item][NumberItem]['Word'] }</th>}
                            <>
                              {(NumberItem !== 'Amount' && NumberItem !== 'GameBoolean') &&<th style={{ padding: 2, borderRight: '1px solid black'}}>{Number(this.state.showTotal[item][NumberItem]['BS']).toFixed(2)}</th>}
                              {(NumberItem !== 'Amount' && NumberItem !== 'GameBoolean') &&<th style={{ padding: 2, borderRight: '1px solid black'}}>{Number(this.state.showTotal[item][NumberItem]['B']).toFixed(2)}</th>}
                              {(NumberItem !== 'Amount' && NumberItem !== 'GameBoolean') &&<th style={{ padding: 2, borderRight: '1px solid black'}}>{Number(this.state.showTotal[item][NumberItem]['S']).toFixed(2)}</th>}
                              {(NumberItem !== 'Amount' && NumberItem !== 'GameBoolean') &&<th style={{ padding: 2, borderRight: '1px solid black'}}>{Number(this.state.showTotal[item][NumberItem]['SA']).toFixed(2)}</th>}
                            </>
                      
                            {(this.state.MinimumShowStatus === 'Show')&& (NumberItem !== 'Amount' && NumberItem !== 'GameBoolean') &&<th style={{ paddingRight: 5, paddingLeft: 5}}>{Number(this.state.GameArray[item][NumberItem]['TotalOrderCount'])}</th>}
                          </tr>
                        })}
                      </tbody>
                    </Table>
                  </div>
                })
                }
              </div>
            </Table>}
          </div>
          {(this.state.GameArray.message === 'No Data') && <div className= "dcc">
            <div className="TitleUsername" style={{ width:  '30%'}}>
              {language[this.props.currentLanguage].GameHavenStart}
            </div>
          </div>}
          {(this.state.PopScrollBackButton)&&<div className={"scroll-to-top iconpopup button2"}  
            onClick={this.elScroll.executeScroll}
          >
            <div  className="icon" style={{ fontSize: 25, fontWeight: 'bold' }}>
        ^
            </div>
          </div>}
        </>
        }
      </div >
    );
  }
}


function mapStateToProps(state, ownProps) {
  return {
    userID: state.userID,
    username: state.username,
    token: state.token,
    Role: state.Role,
    UserAuthority: state.UserAuthority,
    currentLanguage: state.currentLanguage,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    setDate: (Date) => {
      dispatch({
        type: 'SELECTED_DATE',
        payload: Date,
      });
    },
    setLanguage: (lg) => {
      dispatch({ type: 'SET_LANGUAGE', payload: lg });
    },
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(GrandTotalNumberBySBD);